import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../../layout/service/user.service';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'app-notes-show',
    standalone: true,
    imports: [CommonModule, ButtonModule, ToastModule],
    template: `
        <div class="p-8 bg-gray-50 min-h-screen">
            <div>
                <!-- Header -->
                <div class="flex justify-between items-center mb-6">
                    <button pButton icon="pi pi-arrow-left" label="Back" 
                            class="p-button-text" 
                            (click)="goBack()"></button>
                    <div class="flex gap-2">
                        <button pButton icon="pi pi-pencil" label="Edit" 
                                class="p-button-outlined" 
                                (click)="editNote()"></button>
                        <button pButton icon="pi pi-trash" label="Delete" 
                                class="p-button-outlined p-button-danger" 
                                (click)="deleteNote()"></button>
                    </div>
                </div>

                <!-- Note Content -->
                <div *ngIf="note" class="bg-white rounded-2xl shadow-sm p-8 border border-gray-100 overflow-hidden">
                    <!-- Gradient Top -->
                    <div class="h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-t-2xl -mx-8 -mt-8 mb-6"></div>
                    
                    <!-- Content -->
                    <div [innerHTML]="note.note" class="prose prose-lg max-w-none text-gray-700 mb-6 break-words overflow-wrap-anywhere"></div>
                    
                    <!-- Divider -->
                    <div class="border-t border-gray-200 my-6"></div>
                    
                    <!-- Metadata -->
                    <div class="flex items-center gap-2 text-sm text-gray-500">
                        <i class="pi pi-clock"></i>
                        <span>Created: {{ formatDate(note.created_at) }}</span>
                    </div>
                </div>

                <!-- Loading -->
                <div *ngIf="!note" class="flex justify-center items-center h-96">
                    <i class="pi pi-spin pi-spinner text-5xl text-blue-500"></i>
                </div>
            </div>
        </div>
        <p-toast></p-toast>
    `,
    providers: [MessageService]
})
export class NotesShow implements OnInit {
    note: any = null;
    noteId: string = '';

    constructor(
        private userService: UserService,
        private router: Router,
        private route: ActivatedRoute,
        private messageService: MessageService
    ) {}

    ngOnInit() {
        this.noteId = this.route.snapshot.paramMap.get('id') || '';
        this.loadNote();
    }

    loadNote() {
        const userStr = localStorage.getItem('user');
        let userId = '1';
        if (userStr) {
            const user = JSON.parse(userStr);
            userId = user.ID_USER || '1';
        }
        this.userService.getNotes(userId).then(data => {
            const notesArray = data.notes || data.data || (Array.isArray(data) ? data : []);
            this.note = notesArray.find((n: any) => n.id == this.noteId);
        }).catch(err => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load note' });
        });
    }

    goBack() {
        this.router.navigate(['/app/notes']);
    }

    editNote() {
        this.router.navigate(['/app/notes/update', this.noteId]);
    }

    deleteNote() {
        if (confirm('Are you sure you want to delete this note?')) {
            this.userService.deleteNotes({ id: this.noteId }).then(() => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Note deleted' });
                this.router.navigate(['/app/notes']);
            }).catch(err => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete note' });
            });
        }
    }

    formatDate(dateString: string): string {
        const date = new Date(dateString);
        date.setHours(date.getHours() + 7);
        return date.toLocaleString('id-ID', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    }
}